import React from "react";

import { FileField } from "react-admin";

const ShippingNoteField = ({ record = {}, className = "", source, ...rest }) => {
  return <FileField {...rest} record={record} source={source} title="" />;
};

export default ShippingNoteField;
